import { Component, HostListener, OnInit, OnDestroy, enableProdMode, ViewChild } from '@angular/core';
import { SnotifyService, SnotifyPosition, SnotifyToastConfig } from 'ng-snotify';
import { StaticDataService } from '../app/service/static-data.service';
import { AuthenticationService } from './service/authentication.service';
import { SharedDataService } from './service/shared-data.service';
import { Config } from './config/config';
import { RestDataService } from './service/rest-data.service';
import { GoogleAnalyticsService } from './service/google-analytics.service';
import { MessagingService } from './service/messaging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app';
  time: any;
  tokenTimer: any;
  configTimer: any;
  accessTokenValidationCheckTimer: any;
  sessionExpirationWarned: boolean = false;
  style = 'material';
  // title = 'Snotify title!';
  body = 'Lorem ipsum dolor sit amet!';
  timeout = 3000;
  position: SnotifyPosition = SnotifyPosition.rightBottom;
  progressBar = true;
  closeClick = true;
  newTop = true;
  filterDuplicates = false;
  backdrop = -1;
  dockMax = 8;
  blockMax = 6;
  pauseHover = true;
  titleMaxLength = 15;
  bodyMaxLength = 80;
  message: any = "";
  // message;

  constructor(
    private sharedService: SharedDataService,
    private authService: AuthenticationService,
    private snotifyService: SnotifyService,
    private config: Config,
    private restService: RestDataService,
    private gaService:GoogleAnalyticsService,
    private messagingService: MessagingService
  ) {
    // console.log('App comp constructor => ', performance.now());
    if (config.get('production')) {
      if (window) {
        window.console.log = function () { };
        window.console.warn = function () { };
        window.console.info = function () { };
        window.console.error = function () { };
        window.console.assert = function () { };
      }
    }
    this.sharedService.setDomain();
    this.checkConfig();
    this.googleAnalytics();
  }

  ngOnInit() {
    this.time = new Date().getTime();
    const url = (this.config.get('production')) ?
      'https://analytics.htmedia.in/analytics-js/blankpaper.js' : 'https://analytics.dev.htmedia.in/app/trackblankpaper.js';
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.innerHTML = `(function(p, l, o, w, i, n, g) {
        if (!p[i]) {
        p.GlobalTrackerNamespace = p.GlobalTrackerNamespace || [];
        p.GlobalTrackerNamespace.push(i);
        p[i] = function() {
        (p[i].q = p[i].q || []).push(arguments);
        };
        p[i].q = p[i].q || [];
        n = l.createElement(o);
        g = l.getElementsByTagName(o)[0];
        n.async = 1;
        n.src = w;
        g.parentNode.insertBefore(n, g);
        p['platoform'] = "web";
        p['product_id'] = "bp";
        }
        }(window, document, "script", "` + url + `", "dapCollector"));`;
    document.getElementsByTagName('head')[0].appendChild(s);
    setTimeout(() => {
      this.refresh();
    }, 1800000);
    // this.snotify.success('hdsabvsfbfsb');
    this.tokenTimer = setInterval(e => {
      this.checkToken();
      // console.log('event firing');
    }, 5000);
    this.configTimer = setInterval(e => {
      this.checkConfig();
    }, 5000);

    this.accessTokenValidationCheckTimer = setInterval(e => {
      this.checkAccessTokenValidity();
    }, 60000);
    this.messagingService.requestPermission();
    this.messagingService.receiveMessage();
    this.message = this.messagingService.currentMessage;
  }

  checkAccessTokenValidity() {
    let tokenObject: any = localStorage.getItem(StaticDataService.tokenLiteral);
    if(tokenObject!=null && tokenObject!=undefined && tokenObject!={}){
      let accessToken = JSON.parse(tokenObject)['access_token'];
      let tokenExpirationTime = JSON.parse(atob(accessToken.split('.')[1])).exp;
      let currentDate = new Date();
      let currentTime = Math.ceil(currentDate.getTime()/1000);
      let timeToExpire:number = tokenExpirationTime - currentTime;
      let flag: boolean = timeToExpire <= 600;

      if(flag && !this.sessionExpirationWarned){
        this.snotifyService.warning('Please save your work & re-login', 'Session about to expire', this.sharedService.getConfig(false));
        this.sessionExpirationWarned = true;
      }
    }
  }

  @HostListener('window:mousemove', ['$event'])
  activityCheck($event) {
    this.time = new Date().getTime();
    // console.log('time => ' + this.time);
  }

  @HostListener('window:keypress', ['$event'])
  activityCheck2($event) {
    this.time = new Date().getTime();
    const key = $event.keyCode || $event.charCode;
    if (key === 27) {
      this.sharedService.sendData('key27');
    }
    // console.log('time => ' + this.time);
  }

  refresh() {
    // console.log('in refresh');
    if (new Date().getTime() - this.time >= 7200000) {
      window.location.reload(true);
    } else {
      setTimeout(() => {
        this.refresh();
      }, 1800000);
    }
  }

  checkConfig() {
    const time = +localStorage.getItem(StaticDataService.configTimeLiteral);
    if (localStorage.getItem(StaticDataService.domainsConfigLiteral) && time) {
      const data = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral));
      if (new Date().getTime() - time >= 1800000) {
        this.sharedService.setConfig();
      } else {
        const conf = localStorage.getItem(StaticDataService.domainsConfigLiteral);
        const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
        if (conf && domain) {
          this.sharedService.currentDomainConfiguration = JSON.parse(conf)[domain];
        } else {
          this.sharedService.currentDomainConfiguration = StaticDataService.defaultConfig;
        }
      }
    } else {
      this.sharedService.setConfig();
    }
  }

  checkToken() {
    const time = +localStorage.getItem(StaticDataService.timeLiteral);

    if (localStorage.getItem(StaticDataService.tokenLiteral) && time) {
      const data = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral));
      if (new Date().getTime() - time >= 86400000) {
        // window.location.reload(true);
        // this.authService.logout();
        // console.log('logout');
      } else if (new Date().getTime() - time >= 86100000) {
        this.authService.refreshToken().subscribe(
          data2 => {
            console.log('token refreshed', data2);
          },
          error => {
            console.log('refresh token failed', error);
            this.authService.logout();
          });
        // console.log('refresh');
      } else {
        // console.log('session is valid');
      }
    } else {
      // console.log('token not found');
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.tokenTimer);
    clearInterval(this.configTimer);
  }

  getConfig(): SnotifyToastConfig {
    this.snotifyService.setDefaults({
      global: {
        newOnTop: this.newTop,
        maxAtPosition: this.blockMax,
        maxOnScreen: this.dockMax,
        // filterDuplicates: this.filterDuplicates
      }
    });
    return {
      bodyMaxLength: this.bodyMaxLength,
      titleMaxLength: this.titleMaxLength,
      backdrop: this.backdrop,
      position: this.position,
      timeout: this.timeout,
      showProgressBar: this.progressBar,
      closeOnClick: this.closeClick,
      pauseOnHover: this.pauseHover
    };
  }

googleAnalytics(){
this.gaService.gaPageView();
}

}
